import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {

  private timeout: any;
  private idleTime = 120000; // 2 minutes in milliseconds

  constructor(private router: Router, private ngZone: NgZone) { }


  startWatching(isMobile: boolean , isPlus: boolean | null): void {
    this.resetTimer(isMobile, isPlus);
    ['mousemove', 'keydown', 'click'].forEach((event) => {
      window.addEventListener(event, () => this.resetTimer(isMobile, isPlus));
    });
  }

  private resetTimer(isMobile: boolean , isPlus: boolean | null): void {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.logout(isMobile, isPlus), this.idleTime);
  }

  private logout(isMobile: boolean , isPlus: boolean | null): void {
    this.ngZone.run(() => {
      if (isMobile == true) {
        if (isPlus) {
          window.location.href = isPlus == true ? environment.mobile_mychart_logout_url : environment.epic_mychart_logout_url; // Redirect to logout URL
        }
      } else {
        window.location.href = environment.web_mychart_logout_url; // Redirect to logout URL
      }
          
    });
  }
}
